import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/accountsTypes';

const fetchAccountsTypes = createAction('fetchAccountsTypes');

function fetchAccountsTypesSuccess(state, action) {
  const { data } = action.payload;
  state.successFetching = true;
  state.errorFetching = false;
  state.data = data;
}

function fetchAccountsTypesError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.data = [];
}

const accountsTypesReducer = createSlice({
  name: 'accountsTypes',
  initialState,
  reducers: {
    fetchAccountsTypesSuccess,
    fetchAccountsTypesError,
  },
});

export const accountsTypesActions = {
  ...accountsTypesReducer.actions,
  fetchAccountsTypes,
};

export default accountsTypesReducer.reducer;
